export function getMallMenuTitle(path: string): string | undefined {
  switch (path.replace(/^\/+|\/+$/g, "")) {
    case "selfOperatedMall/merchantReview":
      return "入驻商家管理";
    case "selfOperatedMall/merchantWithdrawalReview":
      return "商家提现管理";
    default:
      return undefined;
  }
}
